import { render, staticRenderFns } from "./AuthLayoutNew.vue?vue&type=template&id=5e199237&scoped=true"
import script from "./AuthLayoutNew.vue?vue&type=script&lang=js"
export * from "./AuthLayoutNew.vue?vue&type=script&lang=js"
import style0 from "./AuthLayoutNew.vue?vue&type=style&index=0&id=5e199237&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e199237",
  null
  
)

export default component.exports